import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "@environments/environment";
import { RequestHelper } from "@helper/request.helper";
import { IndodanaService } from "../service/indodana.service";


@Component({
    selector: 'app-indodana-inquiry',
    templateUrl: './indodanainquiry.component.html',
    styleUrls: ['./indodanainquiry.component.css']
})
export class IndodanaInquiryComponent implements OnInit{
    
    form: FormGroup;
    isSubmitted: boolean;
    hostname: any = environment.hostName;
    imgUri : string;
    successPage: number;
    uriCallbackPayment:string;

    appId: number;
    refNumber: string;
    amount: string;
    isValidateButton: boolean;
    redirectUri: string;
    sidePage: string;

    constructor(private apiService:RequestHelper,
        private indodanaService:IndodanaService){}

    ngOnInit(): void {
        console.log("init data indodana")
        console.log("amount from localstorage -> "+localStorage.getItem('indodana_amont'));
        console.log("order id from localstoraga -> "+localStorage.getItem('indodana_orderid'));
        console.log("uri callback -> "+localStorage.getItem('indodana_uri_callback'));
        this.imgUri = "https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/financing/indodana.png"
        this.successPage = 0;
        this.sidePage = 'N';
        this.refNumber = localStorage.getItem('indodana_orderid');
        this.amount = localStorage.getItem('indodana_amont');
        this.uriCallbackPayment = localStorage.getItem('indodana_uri_callback');
        this.form = new FormBuilder().group({
            invoiceNumber: [this.refNumber, [Validators.required]],
            amount: [this.amount, [Validators.required]],
            otp: [null, [Validators.required]]
        })
    }

    doInquiry(){
        console.log("otp => "+JSON.stringify(this.form.controls["otp"].value))
        if (this.form.controls["otp"].value != "00000"){
            console.log("payment error because otp not match");
            this.openDialog("Wrong OTP Value");
        }else{
            console.log("process on inquiry indodana");
            var requestBody = {
                "merchantOrderId" : this.refNumber,
                "password" : "00000"
            }
            console.log("request body payment -> "+JSON.stringify(requestBody))
            this.indodanaService.submitPayment(requestBody).subscribe(response => {
                console.log("response -> "+JSON.stringify(response));
                if (response["status"] == "OK" || response["status"] == "REJECT"){
                    console.log("payment success");
                    this.successPage = 1;
                    this.sidePage = "Y";
                }
            },error => console.log("error from be "+error));
        }   
    }

    openDialog(result){
        this.apiService.openDialog(result, '/paylater-indodana-inquiry');
    }

    paymentDone(){
        console.log("payment done");
        window.location.href = this.uriCallbackPayment;
    }
}